import { ComponentRef } from '@angular/core';
import { DataProvidersResolver } from '@epicuro-next/data-providers/providers-registry';
import { DataContainer } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import {
  ComponentsRelationshipService,
  ErrorCallbacks,
  resolveValue,
  ResolveValueOptions,
} from '@epicuro-next/platform/dynamic-value-resolving';
import { IdProviderService } from 'libs/platform/dynamic-value-resolving/src/lib/services/id-provider.service';
import { isObservable, shareReplay } from 'rxjs';

export function setComponentKeyToData(
  componentKey: string,
  componentRef: ComponentRef<unknown>,
): void {
  const dataContainerHost = componentRef.instance as DataContainer;
  if (dataContainerHost.__data__?.__componentKey__ !== undefined) {
    return;
  }

  if (dataContainerHost.__data__ === undefined) {
    dataContainerHost.__data__ = {
      __componentKey__: componentKey,
    };
  } else {
    dataContainerHost.__data__.__componentKey__ = componentKey;
  }
}

export function setDataOnComponent(
  dataProvidersResolver: DataProvidersResolver,
  componentsRelationshipService: ComponentsRelationshipService,
  idProviderService: IdProviderService,
  componentRef: ComponentRef<unknown>,
  data?: Record<string, unknown>,
  errorCallbacks?: ErrorCallbacks,
): void {
  const dataContainerHost = componentRef.instance as Required<DataContainer>;

  if (!data) {
    return;
  }

  const dataContainer = dataContainerHost.__data__;

  const entries = Object.entries(data);

  if (entries.length === 0) {
    return;
  }

  for (const [propertyName, value] of Object.entries(data)) {
    const options: ResolveValueOptions = {
      overrideWhitelistCheck: true,
    };

    if (
      errorCallbacks !== undefined &&
      errorCallbacks[propertyName] !== undefined
    ) {
      options.errorCallback = errorCallbacks[propertyName];
    }

    let resolvedValue = resolveValue(
      value,
      dataProvidersResolver,
      componentsRelationshipService,
      idProviderService,
      componentRef,
      options,
    );

    const isExpectingObservable = propertyName.endsWith('$');
    if (!isExpectingObservable && isObservable(resolvedValue)) {
      resolvedValue = resolvedValue.pipe(shareReplay(1));
    }
    dataContainer[propertyName] = resolvedValue;
  }
}
